export enum SocialMediaPlatforms {
    LinkedIn = 'LinkedIn',
    Facebook = 'Facebook',
    Instagram = 'Instagram',
    WhatsApp = 'WhatsApp',
}

export const SocialMediaConnections = [
    {
        name: SocialMediaPlatforms.Facebook,
        avatar: 'assets/imgs/socialMedia/facebook.svg',
    },
    {
        name: SocialMediaPlatforms.LinkedIn,
        avatar: 'assets/imgs/socialMedia/linkedIn.svg',
    },
    {
        name: SocialMediaPlatforms.Instagram,
        avatar: 'assets/imgs/socialMedia/instagram.svg',
    },
    {
        name: SocialMediaPlatforms.WhatsApp,
        avatar: 'assets/imgs/socialMedia/whatsapp.svg',
    },
];
